<template>
    <div class="flex min-h-screen min-w-screen">
        <div class="flex flex-col flex-1">
            <Header />
            <div class="flex flex-col flex-1 bg-white xl:flex-row">
                <!-- <SideBarLeft class="w-full xl:w-1/5"/> -->
                <Designer class="w-full xl:w-4/5" />
                <SideBarRight class="w-full xl:w-1/5"/>
            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
    import Header from '@/components/layout/Header.vue'
    // import SideBarLeft from '@/components/layout/SideBarLeft.vue'
    import Designer from '@/components/layout/Designer.vue'
    import SideBarRight from '@/components/layout/SideBarRight.vue'
    import Footer from '@/components/layout/Footer.vue'

    export default {
        components: {
            Header,
            // SideBarLeft,
            Designer,
            SideBarRight,
            Footer
        }
    }
</script>
